/**
 * @author Trung Bui - HaraLoyalty
 * @email trung.builehoai@haravan.com
 * @create date 2022-08-11 15:48:35
 * @modify date 2022-08-11 15:48:35
 * @desc [description]
 */
import { lazy, Suspense } from "react";

interface ILazyLoad {
  cb: any;
  fallback?: any;
}

const defaultProps = {
  cb: () => {},
  fallback: null,
};

// Initial component Loadable
const Loadable = (Component, fallback) => (props) => {
  return (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
};

export const LazyLoad = ({ cb, fallback = null }: ILazyLoad) => {
  return Loadable(lazy(cb), fallback);
};

LazyLoad.defaultProps = defaultProps;
